export default __webpack_public_path__ + "static/media/gordita-medium.aac58c6f.woff2";